import type { CSSProperties } from 'react'
import classNames from 'classnames'
import { cssVar } from 'lib/colors'
import styles from './styles/CircleSpinner.css'

interface CircleSpinnerProps {
  color?: string
  size?: number // Pixels
  className?: string
  progress?: string
  style?: CSSProperties
}

export const CircleSpinner = ({
  color = cssVar('text-link'),
  size = 80,
  progress,
  className = '',
  style = {}
}: CircleSpinnerProps) => {
  const circles = [...Array(4)].map((_, index) => {
    return (
      <div
        key={index}
        className={styles.ringComponent}
        style={{
          borderColor: `${color} transparent transparent transparent`,
          width: size * 0.8,
          height: size * 0.8,
          margin: size * 0.1,
          borderWidth: size * 0.1
        }}
      />
    )
  })

  return (
    <div
      data-testid='circle-spinner'
      className={classNames(styles.sciteLoadingRing, className)}
      style={{ width: size, height: size, ...style }}
    >
      {circles}
      {progress && <span className={styles.percent}>{progress}</span>}
    </div>
  )
}

export default CircleSpinner
